import { render, staticRenderFns } from "./bookContent.vue?vue&type=template&id=0d904ae8&scoped=true&"
import script from "./bookContent.vue?vue&type=script&lang=js&"
export * from "./bookContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d904ae8",
  null
  
)

export default component.exports